/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { useIntl } from 'react-intl'

import { EuiFieldText } from '@elastic/eui'

import PrivacySensitiveContainer from '@modules/cui/PrivacySensitiveContainer'

type Props = {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}

const ApiConsolePath: React.FunctionComponent<Props> = ({ value, onChange, disabled }) => {
  const { formatMessage } = useIntl()

  return (
    <PrivacySensitiveContainer>
      <EuiFieldText
        aria-label={formatMessage({
          id: 'apiConsole.pathLabel',
          defaultMessage: 'Path',
        })}
        fullWidth={true}
        placeholder={formatMessage({
          id: `apiConsole.pathPlaceholder`,
          defaultMessage: `Path, e.g. "_cat/indices"`,
        })}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      />
    </PrivacySensitiveContainer>
  )
}

export default ApiConsolePath
